// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const ms = {
  no: `Tidak`,
  select_country_code: `Pilih Kod Negara`,
  balance: `Baki`,
  loading: `Memuatkan...`,
  requirement: `Keperluan`,
  deposit_from_bank: `Deposit Dari Bank`,
  game: `Permainan`,
  games: `Permainan`,
  sport: `Sukan`,
  center: `Pusat`,
  mines: `MINES`,
  crash: `CRASH`,
  lucky_colour: `LUCKY COLOUR`,
  dice: `DICE`,
  limbo: `LIMBO`,
  lucky_gift: `LUCKY GIFT`,
  all_games: `Semua permainan`,
  game_history: `Sejarah Permainan`,
  coupon_code: `Kod Kupon`,
  telegram: `Telegram`,
  customer_service: `Khidmat Pelanggan`,
  player: `Pemain`,
  winner: `Pemenang`,
  all_bets: `Semua Pertaruhan`,
  my_bets: `Pertaruhan Saya`,
  name: `Nama`,
  time: `Masa`,
  bet_amount: `Jumlah Pertaruhan`,
  prediction: `Ramalan`,
  payout: `Pembayaran`,
  login: `Log masuk`,
  register: `Daftar`,
  username_placeholder: `Nama pengguna`,
  please_input_your_x: `Sila Masukkan {{x}} Anda`,
  affiliate_referral: `ID Rujukan Afiliasi (PILIHAN)`,
  captcha: `CAPTCHA`,
  forgot_password: `Lupa kata laluan`,
  minor_note: `Untuk melawat laman web ini, pastikan anda berumur lebih dari 18 tahun dan bersetuju`,
  terms_of_service: `Syarat Perkhidmatan`,
  by_signing_in: 'Dengan Log Masuk atau Mendaftar, anda bersetuju dengan kami',
  dont_have_account: `Tiada akaun?`,
  sign_up: `Daftar`,
  username: `Nama pengguna`,
  email: `E-mel`,
  full_name: `Nama penuh`,
  confirm_18: `Dengan mengklik butang Daftar, saya dengan ini mengakui bahawa saya berumur lebih dari 18 tahun dan telah membaca serta menerima`,
  already_have_account: `Sudah mempunyai akaun?`,
  share: `Kongsi`,
  transfer: `Pemindahan`,
  deposit: `Deposit`,
  promos: `Promosi`,
  bonus: `Bonus`,
  app: `App`,
  load_more: `Tambah lagi`,
  details: `Butiran`,
  helps: `MEMBANTU`,
  kyc_policy: `Dasar KYC`,
  privacy_policy: `Dasar Privasi`,
  responsible_gaming: `Permainan yang bertanggungjawab`,
  terms_and_condition: `Terma dan syarat`,
  faq: `FAQ`,
  about_us: `TENTANG KITA`,
  about_us_profile: 'Tentang Kita',
  amount: `Jumlah`,
  minimum: `Minima`,
  maximum: `Maks`,
  enter_amount: `Masukkan Jumlah`,
  extra: `Tambahan`,
  deposit_bonus: `Bonus Deposit`,
  do_not_participate: `Jangan sertai promosi`,
  payment_problem: `Masalah Pembayaran`,
  click_for_help: `Klik untuk mendapatkan bantuan`,
  deposit_notes: `Nota Deposit`,
  available_balance: `Baki yang ada`,
  withdraw: `Tarik Diri`,
  withdrawal: `Pengeluaran`,
  withdrawal_notes: `Nota Pengeluaran`,
  withdrawal_note1: `Bilangan pengeluaran semasa`,
  withdrawal_note1_1: `vip`,
  withdrawal_note2: `Yuran pengeluaran:`,
  min: `Min:`,
  max: `Maks:`,
  opening_times: `Masa pembukaan:`,
  withdrawal_note3: `1. Masa pengeluaran terpantas dalam masa 10 minit`,
  withdrawal_note4: `2.Pastikan maklumat pengeluaran anda adalah tepat, jika maklumat pengeluaran salah, ia boleh menyebabkan dana anda hilang.`,
  withdrawal_note5: `3. Sila hubungi kami jika anda mempunyai sebarang pertanyaan.`,
  notifications: `Pemberitahuan`,
  invalid_x: `{{x}} tidak sah`,
  captcha_not_match: `Captcha Tidak Padan`,
  invalid_x_must_be_atleast_y_characters: `{{x}} tidak sah, mestilah sekurang-kurangnya {{y}} aksara`,
  x_is_required: `{{x}} diperlukan`,
  phone_number: 'Nombor telefon',
  phone_num_x_max: `Nombor Telefon maksimum {{x}} digit`,
  email_sent: `E-mel dihantar, sila semak e-mel anda.`,
  enter_valid_email: `Sila masukkan e-mel yang sah.`,
  confirm: `Sahkan`,
  password_atleast_6_characters: `Kata laluan mestilah sekurang-kurangnya 6 aksara.`,
  password_reset_success: `Kejayaan tetapan semula kata laluan!.`,
  new_password: `Kata laluan baharu`,
  bank: 'Bank',
  confirm_logout: `Sahkan Log Keluar?`,
  currency: `mata wang`,
  country: `Negara`,
  uuid: `UUID`,
  change: `Berubah`,
  set_now: `Tetapkan Sekarang`,
  add_birthday: `Tambahkan hari lahir anda`,
  edit_delete_bank_account: `Edit/Padam Akaun Bank`,
  add_bank_account: `Tambah Akaun Bank`,
  delete_bank_account: `Padam Akaun Bank`,
  opps: `Opps!`,
  you_currently_unable: `Pada masa ini anda tidak dapat mengalih keluar/mengedit akaun bank anda. Sila hubungi sokongan pelanggan kami untuk bantuan lanjut.`,
  login_password: `Kata Laluan Masuk`,
  bank_details: `Butiran Bank`,
  edit_profile: 'Edit Profil',
  hint: 'Petunjuk',
  bank_transfer: `Pemindahan bank`,
  bank_name: `Nama bank`,
  account_name: `Nama akaun`,
  account_number: `Nombor akaun`,
  pix_number: `PIX Number`,
  drop_or_select: `Lepaskan atau Pilih fail`,
  drop_files_here: `Lepaskan fail di sini`,
  transfer_to: `Pemindahan Kepada`,
  upload_receipt: `Muat Naik Resit`,
  select_bonus: `Pilih Bonus`,
  no_promotion: `Tiada Promosi`,
  please_upload_receipt: `Sila muat naik resit`,
  bank_account: `Akaun bank`,
  add_account: `Tambah akaun`,
  account_holder_name: `Nama Pemegang Akaun`,
  name_of_the_account_holder: `Nama Pemegang Akaun`,
  fill_in_bank_account: `Isikan Akaun Bank`,
  withdraw_information: `Tarik balik Maklumat`,
  note: `Catatan`,
  amount_withdrawn: `Jumlah yang dikeluarkan`,
  amount_no_exceed_balance: `Jumlah Pengeluaran tidak boleh melebihi baki yang ada`,
  minimum_withdraw_amount_is_x: `Jumlah Pengeluaran Minimum ialah {{x}}`,
  transaction_history: `Sejarah Transaksi`,
  date_from: `Tarikh dari`,
  date_to: `Tarikh Kepada`,
  account_name_must_be_4: `Nama Akaun mestilah lebih besar daripada 4 panjang`,
  account_number_must_be_x: `Nombor akaun mestilah 10-14 panjang`,
  minimum_length_is_x: `Minimum length is {{x}}`,
  maximum_length_is_x: `Maximum length is {{x}}`,
  payment_method: `Kaedah Pembayaran`,
  mode: `Mode`,
  no_bank_account: `Anda tidak mempunyai sebarang akaun untuk dikeluarkan, Tambah sekarang`,
  please_select_bank: `Sila pilih Akaun Bank`,

  bet_history: `Sejarah Pertaruhan`,
  game_provider: `Penyedia Permainan`,
  bet_count: `Kiraan Pertaruhan`,
  win_loss: `Menang/Kalah`,
  rebate: `Rebat`,
  turnover: `Perolehan`,
  game_category: `Kategori Permainan`,

  you_have_x_unread_messages: `Anda mempunyai {{x}} mesej yang belum dibaca`,
  deposit_amount_between_x_and_y: `Amaun deposit mestilah antara {{x}} dan {{y}}`,
  minimum_amount_is_x_y: `Jumlah minimum ialah {{x}}{{y}}`,

  // all
  all: `Semua`,
  title: `Tajuk`,
  date: `Tarikh`,
  type: `Taip`,
  status: `Status`,
  remark: `Teguran`,
  category: `kategori`,
  please_select_x: `Sila pilih {{x}}`,
  save: `Jimat`,

  change_password: `Tukar kata laluan`,
  current_password: `Kata Laluan Semasa`,
  confirm_password: `Sahkan Kata Laluan Baharu`,
  submit: `Hantar`,
  password_changed: `Kata Laluan Ditukar`,
  x_must_be_y_characters: `{{x}} mestilah sekurang-kurangnya {{y}} aksara`,
  reset_password: `Menetapkan semula kata laluan`,
  casino: `Kasino`,
  slots: `Slot`,
  live_casino: `Kasino Langsung`,
  fishing: `Memancing`,
  sports: `Sukan`,
  cards: `Kad`,
  no_bank_accounts_added: `Tiada akaun bank ditambahkan`,
  clear: `Jelas`,
  search: `Cari`,
  new: `Baru`,
  logout: `Log keluar`,
  choose_date: `Pilih Tarikh`,
  select_both_date: `Pilih kedua-dua Tarikh Dari dan Kepada`,
  from: `daripada`,
  to: `Kepada`,
  apply: `Mohon`,
  promotions: `Promosi`,
  learn_more: `KETAHUI LEBIH LANJUT`,
  password_doesnt_match: `Kata laluan tidak sepadan`,
  cancel: `Batal`,
  confirm_to_pay: `Sahkan Untuk Bayar`,
  deposit_amount: `Jumlah Deposit`,
  loading_please_wait: `Muat turun sila tunggu`,
  account: `Akaun`,
  profile: `Profil`,
  bank_list: `Senarai Bank`,
  in_maintenance: `Dalam Penyelenggaraan`,
  birthday: `Hari Jadi`,
  birthday_bonus: `Hari Lahir Bonus`,
  referral_code: `Kod rujukan`,
  referral: `Rujukan`,
  my_referral: `Rujukan Saya`,
  my_claim: `Tuntutan Saya`,
  claim_profit: `TUNTUTAN UNTUNG`,
  available_profit: `Keuntungan yang Tersedia`,
  claimed_profit: `Keuntungan yang Dituntut`,
  all_time_profit: `Keuntungan Sepanjang Masa`,
  referral_note_on_x: `Peroleh keuntungan setiap kali rakan anda bermain di {{x}}`,
  tier: `Peringkat`,
  commission: `Suruhanjaya`,
  referred_member: `Ahli yang dirujuk`,
  profit_earned: `Keuntungan Diperolehi`,
  account_information: `Maklumat Akaun`,
  invite_friends: `Menjemput kawan-kawan`,
  how_it_work: `Bagaimana ia berfungsi?`,
  invite_note: `Dapatkan bonus rujukan eksklusif apabila rakan anda mendaftar menggunakan kod rujukan anda!`,
  share_via: `Kongsi melalui`,
  referral_link: `Pautan Rujukan`,
  total_profit: `Jumlah Keuntungan`,
  must_start_with: `Mesti bermula dengan (rangkaian yang sah iaitu 010, 011, 012, 013, 014, 015, 016, 017, 018, 019)`,
  copied: `Disalin`,
  nothing_to_claim: `Tiada apa-apa untuk dituntut`,
  claim_history: `Sejarah Tuntutan`,
  downline: `Downline Saya`,
  last_x_digit_bank_ref_number: `{{x}} digit terakhir nombor Ruj Bank`,
  bank_ref_number_validation_x: `Nombor Rujukan Bank diperlukan dan mestilah {{x}} panjang aksara`,
  sort: 'Susun',
  login_directly: 'Log masuk terus dengan',
  our_game_provides: 'PENYEDIA PERMAINAN KAMI',
  we_accept_below_bank: `Kami Terima Bank-Bank Berikut`,
  we_accept_payment_methods: `Kami Terima Kaedah Pembayaran`,
  refer_and_reward: 'Rujuk & Ganjaran',
  linked_successfully_x: 'Berjaya disambungkan dengan {{x}}! Sila daftar akaun anda untuk kali pertama',
  more_x_of_y: 'Lebih {{x}}/{{y}}',
  default: 'Default',
  promotion: 'Promosi',
  daily_mission: 'Misi Harian',
  agent: 'Ejen',
  contact_us: 'Hubungi Kami',
  download: 'Muat Turun',
  cash_claim: 'Tuntutan Tunai',
  demo: 'Demo',
  favorites: 'Kegemaran',
  popular: 'Popular',
  claim_bonus: 'Tuntut Bonus',
  insufficient_balance: 'Baki Tidak Cukup',
  currently_displaying: 'Sedang memaparkan {{x}} {{y}} permainan daripada {{z}}',
  all_x: 'Semua {{x}}',
  no_results: 'Tiada Keputusan Ditemui',
  search_games: 'Cari Permainan',
  please_scan_using_your: 'Sila imbas menggunakan {{y}}',
  vip_level: 'Tahap VIP',
  bonus_direct: 'BONUS LANGSUNG',
  rebate_level: 'Tahap Rabat',
  vip_header:
    'Semua pertaruhan yang diletakkan pada Mesin Slot, Papan dan Permainan Kad, Memancing, Video, Sukan dan Permainan Loteri di Jit993 akan dikumpulkan secara kekal. Pertaruhan sah = Pendapatan Kekal dan Kekayaan Wang!',
  vip_example:
    'Contoh 1: Ahli yang mencapai 1 Juta dalam deposit yang terkumpul, mencapai Tahap VIP 2, menerima bonus sebanyak R$210, dan Rebate 3.50%, Apabila mereka mencapai 6 Juta dalam deposit yang terkumpul, mereka mencapai Tahap VIP 3 dan menerima bonus sebanyak R$800, dengan Rebate 4%.',
  activity_rules: 'Peraturan Aktiviti:',
  activity_rules_1: '1. Adalah wajib bagi semua bonus mempunyai x3 Pusingan untuk meminta Pengeluaran.',
  activity_rules_2:
    '2. Sila tuntut Bonus Rebate dalam tempoh masa yang ditetapkan, jika anda lewat, ia akan dianggap sebagai penampan;',
  activity_rules_3:
    '3. Penyertaan ahli dalam aktiviti akan dikira secara automatik oleh sistem, jika ada sebarang bantahan, hasil siasatan Jit993 akan diutamakan;',
  activity_rules_4:
    "4. Jika anda lupa akaun Ahli/Kata Laluan anda, sila hubungi 'Perkhidmatan Pelanggan 24 Jam Online' untuk membantu anda mendapatkan semula maklumat akaun anda;",
  activity_rules_5: '5. Jit993 berhak untuk mengubah, menghentikan atau membatalkan promosi ini pada bila-bila masa.',
  activity_rules_6: '6. Jangan menyimpan permainan percuma, Beli permainan percuma',
  activity_rules_7: '7. Tidak boleh digabungkan dengan mana-mana bonus',
  activity_rules_8: '8. Pengeluaran Maksimum setiap Deposit adalah R$100,000.00',
  event_instructions: 'Arahan Acara',
  agent_p1: 'Kongsi pautan unik anda di seluruh aplikasi dan media sosial',
  agent_p2:
    'Facebook, Instagram, Tiktok, Telegram, WhatsApp, YouTube, dan lain-lain, cepatlah dan jemput semua orang, ahli yang mendaftar melalui pautan eksklusif anda akan menjadi ejen langsung anda. Tetapi perhatikan kerana ahli baru yang anda jemput mesti adalah tulen dan sah.',
  agent_step1:
    'Dapatkan jemputan rakan apabila deposit pertama berjaya, anda boleh memenangi bonus sebanyak R$5. sebagai contoh, jika anda menjemput 10 orang untuk deposit pertama, anda boleh mendapatkan R$50. Semakin ramai orang yang anda jemput, semakin banyak bonus yang akan anda terima. Anda boleh melihat sejarah anda dan mendaftar di laman promosi untuk bonus dan komisen tinggi.',
  agent_step2:
    'Jika tetamu anda bertaruh R$1 atau lebih, anda sudah boleh menikmati komisen tinggi! Anda boleh mendapatkan sehingga 5% komisen seumur hidup, dan jemputan seumur hidup! Sistem akan menyelesaikan komisen hari sebelumnya pada jam 7 pagi pada hari berikutnya.',
  agent_step2_1: 'Cara untuk mendapatkan: Log masuk - Promosi jemputan - Kumpul komisen',
  agent_table1: 'Kadar komisen pertaruhan untuk slot, memancing dan blockchain adalah seperti berikut:',
  agent_table1_1: 'Pelanggan topup 20 bertaruh 200',
  person: 'orang',
  agent_table2_title1: 'Pertaruhan Ahli',
  agent_table2_title2: 'Hanya Permainan Slot',
  agent_table2_example:
    'Contoh: Anda mempunyai 100 ahli, dan nilai sebenar pertaruhan keseluruhan dianggarkan pada 1 juta reais sehari. Komisen yang anda terima pada hari itu adalah: 1,000,000 x 1.20% = 12,000 reais. Pendapatan bulanan sebanyak 100,000 adalah sangat mudah untuk dicapai.',
  reminder: 'Peringatan',
  agent_reminder:
    'Akaun ahli dengan alamat IP yang sama, peranti yang sama, nama, kad bank, dan maklumat lain hanya boleh menyertai sekali, dan sesiapa yang melanggar peraturan ini tidak akan mendapat manfaat daripada bonus ini. atau kumpulan akan dirampas dan akaun akan dibekukan secara kekal',
  agent_step3_1:
    'Penyertaan ahli dalam aktiviti diira secara automatik oleh sistem, jika ada sebarang bantahan, hasil analisis yang dilakukan oleh Jit993 akan diutamakan',
  agent_step3_2:
    'Jika anda lupa akaun ahli/kata laluan anda, sila hubungi pasukan perkhidmatan pelanggan kami yang beroperasi 24 jam untuk membantu anda mendapatkan semula maklumat akaun anda',
  agent_step3_3: 'Jit993 berhak untuk mengubah, menghentikan atau membatalkan promosi pada bila-bila masa',
  agent_step3_4: 'Ejen yang menerima bonus komisen adalah dalam bentuk tunai atau kredit dalam dompet',
  agent_step3_5: 'Jangan menyimpan permainan percuma, Beli permainan percuma',
  agent_step3_6: 'Tidak boleh digabungkan dengan sebarang bonus dan deposit',
  agent_step3_7: 'Hanya tersedia untuk permainan Slot',
  promo_concluded: 'Promosi telah tamat! Semak semula esok!',
  can_only_claim: 'Hanya boleh tuntut bonus antara {{x}} hingga {{y}} Waktu Brazil',
  please_login: 'Sila Log Masuk terlebih dahulu untuk menuntut bonus!',
  back_to_home: 'Kembali ke Laman Utama',
  bonus_claimed: 'Bonus Telah Dituntut!',
  wallet: 'Dompet',
  bank_bsb: 'BSB Bank',
  pay_id: 'PayID',
  from_selected_promotion: 'daripada promosi terpilih',
  helpful_links: 'Pautan Berguna',
  platform: 'Platform',
  community: 'Komuniti',
  support: 'Sokongan',
  partnership_program: 'Program Rakan Kongsi',
  help_center: 'Pusat Bantuan',
  sports_policy: 'Dasar Sukan',
  aml_policy: 'Dasar AML',
  level: 'Level',
  back: 'Belakang',
  network_error: 'Ralat Rangkaian',
  we_have_sent_otp: 'Kami telah menghantar OTP ke nombor telefon anda',
  your_otp_expire: 'OTP anda akan tamat tempoh dalam',
  didnt_receive: 'Tidak menerima mesej?',
  send_again: 'Hantar semula',
  resend_again: 'Hantar semula sekali lagi',
  invalid_verification: 'Kod pengesahan tidak sah!',
  otp_expired: 'OTP tamat tempoh, sila masukkan semula nombor telefon anda dan cuba lagi!',
  otp_expired_redirect: 'OTP tamat tempoh! mengubah hala ke log masuk',
  captcha_check_failed: 'Semakan Captcha Gagal!',
  verify_phonenumber: 'Sahkan Nombor Telefon',
  send_otp: 'Hantar OTP',
  success_verification: 'Nombor Telefon anda telah disahkan!',
  press_get_code: 'Tekan Butang GET CODE Untuk Menerima Kod Pengesahan Melalui SMS',
  otp_sent: 'Kod Pengesahan Dihantar! Masukkan kod pengesahan di bawah untuk meneruskan',
  get_code: 'Dapatkan kod',
  verify: 'Verify',
  verification_code: 'Kod pengesahan',
  otp_not_found: 'Fungsi OTP Tidak Ditemui!',
  terms_n_conditions: `TERMA DAN SYARAT`,
  the_activity_x_in: `Aktiviti {{x}} Dalam`,
  starts: `Bermula`,
  ends: `Tamat`,
  list_of_winners: `SENARAI PEMENANG`,
  days: `Hari`,
  hours: `Hours`,
  minutes: `Minit`,
  seconds: `Detik`,
  total_amount_received: `Jumlah Jumlah Diterima`,
  claim: `Tuntutan`,
  please_select_lang: `Sila pilih bahasa pilihan anda`,
  affiliates: `Afiliasi`,
  requirement_to_withdraw: `Keperluan untuk menarik diri:`,
  total_bet_x: `Jumlah Pertaruhan {{x}}`,
  x_of_y: `{{x}} daripada {{y}}`,
  no_balance: `Tiada Baki`,
  fullname_note: `Pastikan nama penuh anda sepadan dengan akaun bank anda untuk mengelakkan masalah pengeluaran.`,
  number_exists: 'Nombor telefon ini sudah didaftarkan!',
  number_not_exists: 'Nombor telefon ini tidak didaftarkan!',
  payment_draft:
    'Jika anda mengesahkan anda telah membayar, sila tunggu sebentar kerana pembayaran mungkin masih diproses',
  live_chat: 'Perbualan Langsung',
  please_download_x_to_play: 'Sila muat turun {{x}} untuk bermain.',
  password: 'Kata Laluan',
  play_now: 'Main Sekarang',
  vip_benefits: 'Faedah VIP',
  no_limits: 'Tiada Had',
  no_limits_description:
    'Kami menawarkan perkhidmatan VIP peribadi dengan syarat permainan unik kepada semua pemain di kelab VIP. Kini anda boleh bermain tanpa sebarang kebimbangan! Ia sangat mudah - bermain untuk keseronokan, memperbaiki kemahiran permainan anda, menikmati masa anda dan tiada had pada peluang kemenangan anda!',
  financial_privileges: 'Keistimewaan Kewangan',
  financial_privileges_description:
    'Kelab VIP mengalu-alukan semua pemain yang ingin mendapatkan perkhidmatan VIP berkualiti tinggi. Keistimewaan eksklusif, promosi dan faedah khas tersedia untuk anda di Laman Web kami! Status pemain VIP membuka had pengeluaran yang lebih tinggi dalam masa yang sangat singkat! Nikmatilah!',
  personal_manager: 'Pengurus Peribadi',
  personal_manager_description:
    'Apakah kelebihan yang anda ingin dapatkan apabila anda menjadi pemain VIP? Kongsikan pendapat anda dengan pengurus peribadi anda dan beritahu kami apa lagi yang anda ingin lihat di Laman Web kami! Kami sentiasa terbuka untuk cadangan yang hebat!',
  vip_promotions: 'Promosi VIP',
  vip_promotions_description:
    'Adakah anda ingin mendapatkan lebih banyak promosi hebat, pemain VIP menikmati semua ini dan banyak lagi sebagai ganjaran untuk kesetiaan! Jadilah salah seorang daripada mereka!',
  become_vip: 'Jadi VIP',
  play_the_way_you_want: 'Main seperti yang anda mahu',
  join_vip_program: 'Sertai Program VIP Sekarang!',
  join_now: 'Sertai Sekarang',
  vip_club: 'Kelab VIP',
  withdraw_limit: 'Had Pengeluaran',
  cashback: 'Pulangan Tunai',
  personal_account_manager: 'Pengurus Akaun Peribadi',
  dont_show_again: 'Jangan tunjuk lagi',
  next: 'Seterusnya',
  close: 'Tutup',
  logout_confirmation: 'Pengesahan Log Keluar',
  are_you_sure_to_logout: 'Adakah anda pasti mahu log keluar?',
  you_can_reach_media_platforms: 'Anda boleh menghubungi kami melalui mana-mana platform media sosial kami',
  no_data: 'Tiada Data',
  total_deposit_in_a_month: `Jumlah Deposit dalam Sebulan`,
  daily_withdraw_limit: `Had Pengeluaran Harian`,
  transaction_counts: `Kiraan Transaksi`,
  vip_birthday_bonus: `Bonus Hari Lahir`,
  daily_rebate: `Rebat Harian`,
  vip_maintenance_3_mo: `Penyelenggaraan VIP selama 3 bulan`,
  see_all: `Lihat Semua`,
  home: 'Laman Utama',
  total_deposit: `Jumlah Deposit`,
  more_games: `More Games`,
  favorite_game: `Permainan Kegemaran`,
  total_balance: `Jumlah Baki`,
  language: `Bahasa`,
  vip_center: `Pusat VIP`,
  join_community: `Sertai Komuniti Kami`,
  preferred_bank: `Bank Pilihan`,
  account_holder: `Pemegang akaun`,
  select_bank: `Pilih Bank`,
  enter_here: `Masuk sini`,
  today: `Hari ini`,
  all_type: `Semua Jenis`,
  no_record_found: `Tiada Rekod Ditemui`,
  yesterday: `Semalam`,
  last_three_days: '3 Hari Terakhir',
  last_seven_days: '7 Hari Terakhir',
  last_15_days: '15 Hari Terakhir',
  last_30_days: '30 Hari Terakhir',
  date_time: `Tanggal & Waktu`,
  transaction_id: `ID Transaksi`,
  transaction_type: `Jenis Transaksi`,
  successful: `Berhasil`,
  approve: `Menyetujui`,
  completed: `Selesai`,
  pending: `Tertunda`,
  failed: `Gagal`,
  mobile: `Mudah alih`,
  enter_code: `Masukkan kod tersebut`,
  request_otp: `Minta OTP`,
  continue: `teruskan`,
  sending: `Menghantar...`,
  resend_in: `Hantar semula masuk`,
  please_enter_new_password: 'Sila masukkan kata laluan baharu anda',
  password_contain: `Kata laluan mesti mengandungi sekurang-kurangnya`,
  six_characters: `Sekurang-kurangnya 6 aksara`,
  contains_letters_numbers: `Mengandungi huruf dan nombor`,
  enter_new_password: `Masukkan kata laluan baharu`,
  confirm_new_password: `Sahkan kata laluan baharu`,
  receipt: `Resit`,
  important_notice: `Notis Penting`,
  always_check_for_latest_active: `Sentiasa semak butiran bank deposit aktif terkini sebelum membuat deposit.`,
  depositors_name_must_match: `NAMA AKAUN Pendeposit mesti sepadan dengan nama penuh yang didaftarkan. Kami tidak menggalakkan transaksi dibuat menggunakan akaun pihak ke-3/syarikat.`,
  for_using_bank_transfer: `Untuk menggunakan pilihan deposit "Pindahan Bank", Sila buat pindahan sebelum menyerahkan transaksi untuk mengelakkan transaksi kelewatan.`,
  please_do_not_fill_sensitive: `Tolong JANGAN isikan sebarang perkataan sensitif yang berkaitan dengan perjudian sebagai rujukan/teguran dalam transaksi pemindahan dalam talian anda.`,
  please_take_note: `Sila ambil perhatian bahawa 1x pusing ganti diperlukan untuk semua deposit yang dibuat sebelum sebarang pengeluaran boleh diproses.`,
  kindly_check_live_chat: `Sila semak dengan LIVECHAT 24/7 kami jika transaksi anda belum selesai lebih daripada 5 minit.`,
  min_amount: `Jumlah min`,
  minimum_deposit_is: `Deposit minimum ialah`,
  deposit_channel: `Saluran deposit`,
  remember_password: `Ingat Kata Laluan`,
  enter_password: `Masukkan Kata Laluan`,
  dont_you_have_account: `Tiada akaun?`,
  create_account_now: `Buat akaun sekarang`,
  contact_number: `Nombor Perhubungan`,
  enter_account_number: `Nombor Perhubungan`,
  select_currency: `Pilih Mata Wang`,
  i_agree_the: `Saya bersetuju`,
  terms_of_use: `Syarat penggunaan`,
  and: `dan`,
  wallet_balance: `Baki Wallet`,
  restore: `Pulihkan`,
  others: `Lain-lain`,
  havent_login_yet: `Belum Log Masuk lagi...`,
  login_register_now: `Log masuk/Daftar Sekarang!`,
  hot_news: `BERITA PANAS`,
  daily_checkin: `Daftar Masuk Harian`,
  total_earn: `Jumlah Perolehan`,
  double_reward_checkin: `Ganjaran berganda untuk daftar masuk berterusan untuk`,
  claim_now: `Tuntut Sekarang`,
  check_in_history: `Sejarah Daftar Masuk`,
  no_history_yet: `Belum Ada Sejarah`,
  more: `Lagi`,
  from_provider: `Daripada Pembekal`,
  to_provider: `Kepada Pembekal`,
  transfer_amount: `Jumlah Pemindahan`,
  available_amount: `Jumlah Tersedia`,
  turnover_requirement: `Keperluan Pusing Ganti`,
  promo_code: `Kod Promosi`,
  enter_your_promo_code: `Masukkan kod promosi anda`,
  select_provider: `Pilih Pembekal`,
  phone_number_not_associated: `Nombor telefon ini tidak dikaitkan dengan mana-mana akaun, sila masukkan semula.`,
  old_password: `Kata Laluan Lama`,
  id: `ID`,
  how_to_deposit: `Bagaimana nak deposit?`,
  how_to_withdrawal: `Bagaimana cara pengeluaran?`,
  how_to_top_up: `Bagaimana untuk menambah nilai?`,
  how_to_add_homescreen: `Bagaimana untuk menambah pada skrin utama?`,
  search_game_name: `Cari nama permainan`,
  please_enter_correct_username: `Sila masukkan Nama Pengguna yang betul`,
  please_enter_correct_password: `Sila masukkan Kata Laluan yang betul`,
  enter_username: `Masukkan Nama Pengguna`,

  our_commitment: `Komitmen Kami`,
  our_commitment_desc: `Kami komited untuk mempromosikan permainan yang bertanggungjawab dan memastikan platform kami kekal sebagai persekitaran yang selamat, terkawal, dan menyeronokkan untuk semua pemain. Walaupun permainan bertujuan sebagai hiburan, kami memahami kepentingan membantu pengguna mengekalkan tabiat yang sihat serta kawalan terhadap aktiviti mereka.`,
  play_responsibly: `Bermain Secara Bertanggungjawab`,
  play_subtitle: `Kami menggalakkan semua pemain untuk:`,
  play_responsibly_desc1: `Menganggap permainan sebagai hiburan, bukan sumber pendapatan`,
  play_responsibly_desc2: `Menetapkan had peribadi terhadap masa dan perbelanjaan`,
  play_responsibly_desc3: `Mengelakkan mengejar kerugian`,
  play_responsibly_desc4: `Mengambil rehat secara berkala semasa bermain`,
  play_responsibly_desc5: `Hanya bermain menggunakan wang yang anda mampu untuk rugi`,
  underage_protection: `Perlindungan Bawah Umur`,
  underage_protection_subtitle1: `Platform kami melarang sama sekali akses kepada individu di bawah umur 18 tahun (atau umur sah di bidang kuasa masing-masing).`,
  underage_protection_subtitle2: 'Kami mengambil langkah aktif untuk mencegah permainan bawah umur, termasuk:',
  underage_protection_desc1: `Prosedur pengesahan identiti`,
  underage_protection_desc2: `Pemantauan akaun`,
  underage_protection_desc3: `Penggantungan serta-merta bagi akaun yang didapati di bawah umur`,
  self_control_tools: `Alat Kawalan Diri`,
  self_control_tools_subtitle1: `Bagi menyokong permainan yang bertanggungjawab, kami menyediakan alat untuk membantu pemain mengurus aktiviti mereka, termasuk:`,
  self_control_tools_desc1: `Had deposit`,
  self_control_tools_desc2: `Peringatan masa sesi`,
  self_control_tools_desc3: `Tempoh rehat (cooling-off)`,
  self_control_tools_desc4: `Pilihan pengecualian diri (self-exclusion)`,
  self_control_tools_subtitle2: `Pemain yang ingin berehat boleh menghubungi pasukan sokongan kami untuk bantuan mengaktifkan ciri-ciri ini.`,
  sign_of_problem_gaming: `Tanda-Tanda Masalah Permainan`,
  sign_of_problem_gaming_subtitle1: `Jika anda mengalami mana-mana tanda berikut, mungkin sudah tiba masanya untuk berehat:`,
  sign_of_problem_gaming_desc1: `Membelanjakan lebih banyak wang atau masa daripada yang dirancang`,
  sign_of_problem_gaming_desc2: `Meminjam wang untuk berjudi`,
  sign_of_problem_gaming_desc3: `Terus mengejar kerugian`,
  sign_of_problem_gaming_desc4: `Mengabaikan kerja, keluarga, atau tanggungjawab`,
  sign_of_problem_gaming_desc5: `Berasa tertekan, cemas, atau kecewa akibat permainan`,
  sign_of_problem_gaming_subtitle2: `Mengenal pasti tanda-tanda ini lebih awal adalah sangat penting.`,
  support_and_assistance: `Sokongan & Bantuan`,
  support_and_assistance_subtitle1: `Jika anda atau seseorang yang anda kenali mungkin menghadapi masalah berkaitan perjudian, kami sangat menggalakkan anda mendapatkan bantuan profesional. Terdapat banyak organisasi yang menyediakan sokongan dan panduan secara sulit.`,
  support_and_assistance_subtitle2: `Anda boleh mempertimbangkan untuk menghubungi:`,
  support_and_assistance_desc1: `Perkhidmatan kaunseling tempatan`,
  support_and_assistance_desc2: `Organisasi sokongan profesional`,
  support_and_assistance_desc3: `Talian bantuan nasional di negara anda`,
  our_responsibility: `Tanggungjawab Kami`,
  our_responsibility_subtitle1: `Kami secara aktif memantau aktiviti pemain untuk mengesan tingkah laku yang luar biasa atau berpotensi memudaratkan. Jika perlu, kami boleh:`,
  our_responsibility_desc1: `Memberikan panduan atau amaran`,
  our_responsibility_desc2: `Mencadangkan had atau tempoh rehat`,
  our_responsibility_desc3: `Mengehadkan akses buat sementara waktu bagi melindungi pemain`,
  contact_us_responsible: `Hubungi Kami`,
  contact_us_subtitle: `Jika anda memerlukan bantuan atau ingin mengaktifkan mana-mana alat permainan bertanggungjawab, sila hubungi pasukan sokongan kami. Kami sedia membantu anda mengekalkan pengalaman yang selamat dan menyeronokkan.`,

  by_accessing_our_platform: `Dengan mengakses dan menggunakan platform kami, anda bersetuju untuk mematuhi serta terikat dengan Terma & Syarat ini. Jika anda tidak bersetuju, sila hentikan penggunaan perkhidmatan kami.`,
  we_reserve_rights: `Kami berhak untuk mengubah, mengemas kini, atau meminda terma ini pada bila-bila masa tanpa notis terlebih dahulu. Penggunaan berterusan platform ini dianggap sebagai penerimaan terhadap terma yang telah dikemas kini.`,
  eligibility: `Kelayakan`,
  eligibility_desc1: `Pengguna mestilah berumur sekurang-kurangnya 18 tahun (atau umur sah di bidang kuasa masing-masing).`,
  eligibility_desc2: `Pengguna bertanggungjawab memastikan bahawa permainan dalam talian adalah sah di negara mereka.`,
  eligibility_desc3: `Kami berhak untuk menggantung atau menamatkan akaun yang tidak memenuhi syarat kelayakan.`,
  account_responsibility: `Tanggungjawab Akaun`,
  account_responsibility_desc1: `Pengguna mesti memberikan maklumat yang tepat dan lengkap semasa pendaftaran.`,
  account_responsibility_desc2: `Setiap pengguna hanya dibenarkan mempunyai satu akaun sahaja.`,
  account_responsibility_desc3: `Pengguna bertanggungjawab menjaga kerahsiaan maklumat log masuk mereka.`,
  account_responsibility_desc4: `Sebarang aktiviti di bawah akaun anda adalah tanggungjawab anda sepenuhnya.`,
  deposit_withdrawal: `Deposit & Pengeluaran`,
  deposit_withdrawal_desc1: `Semua deposit mesti dibuat melalui kaedah pembayaran yang diluluskan.`,
  deposit_withdrawal_desc2: `Pengeluaran tertakluk kepada proses pengesahan dan pematuhan.`,
  deposit_withdrawal_desc3: `Kami berhak untuk menangguhkan atau menolak pengeluaran sekiranya terdapat aktiviti mencurigakan.`,
  deposit_withdrawal_desc4: `Tempoh pemprosesan mungkin berbeza bergantung kepada penyedia pembayaran.`,
  bonuses_promotions: `Bonus & Promosi`,
  bonuses_promotions_desc1: `Semua bonus, ganjaran, dan promosi tertakluk kepada terma tertentu.`,
  bonuses_promotions_desc2: `Penyalahgunaan promosi (termasuk akaun berganda atau penipuan) adalah dilarang sama sekali.`,
  bonuses_promotions_desc3: `Kami berhak untuk membatalkan bonus dan kemenangan yang diperoleh melalui penyalahgunaan.`,
  fair_play_usage: `Permainan Adil & Penggunaan`,
  fair_play_usage_desc1: `Pemain mesti menggunakan platform secara adil dan sah.`,
  fair_play_usage_desc2: `Sebarang cubaan untuk memanipulasi permainan, mengeksploitasi ralat sistem, atau melakukan penipuan adalah dilarang.`,
  fair_play_usage_desc3: `Sekiranya berlaku ralat sistem, kami berhak untuk membatalkan pertaruhan dan kemenangan yang terjejas.`,
  multiple_accounts_ip_policy: `Polisi Akaun Berganda & IP`,
  multiple_accounts_ip_policy_desc1: `Akaun berganda oleh pengguna yang sama adalah dilarang sama sekali.`,
  multiple_accounts_ip_policy_desc2: `Jika didapati beberapa akaun berkongsi alamat IP yang sama atau mempunyai aktiviti berkaitan, kami berhak untuk:`,
  multiple_accounts_ip_policy_desc2_1: `Menggantung atau menamatkan akaun`,
  multiple_accounts_ip_policy_desc2_2: `Membatalkan semua kemenangan`,
  multiple_accounts_ip_policy_desc2_3: `Memulangkan hanya jumlah deposit asal`,
  provider_game_issues: `Isu Provider & Permainan`,
  provider_game_issues_desc1: `Permainan dikendalikan oleh penyedia pihak ketiga.`,
  provider_game_issues_desc2: `Sekiranya berlaku isu teknikal, ralat, atau percanggahan daripada provider, kami berhak untuk:`,
  provider_game_issues_desc2_1: `Melaraskan baki akaun sewajarnya`,
  provider_game_issues_desc2_2: `Membatalkan pertaruhan atau kemenangan yang terjejas`,
  provider_game_issues_desc3: `Sebarang keputusan berdasarkan laporan provider adalah muktamad.`,
  account_suspension_termination: `Penggantungan & Penamatan Akaun`,
  account_suspension_termination_subtitle: `Kami berhak untuk menggantung atau menutup akaun secara kekal sekiranya:`,
  account_suspension_termination_desc1: `Terma & Syarat dilanggar`,
  account_suspension_termination_desc2: `Aktiviti penipuan atau mencurigakan dikesan`,
  account_suspension_termination_desc3: `Proses pengesahan yang diperlukan tidak diselesaikan`,
  limitation_of_liability: `Had Tanggungjawab`,
  limitation_of_liability_subtitle: `Kami tidak bertanggungjawab terhadap:`,
  limitation_of_liability_desc1: `Kerugian akibat kecuaian pengguna`,
  limitation_of_liability_desc2: `Masalah teknikal di luar kawalan kami`,
  limitation_of_liability_desc3: `Kelewatan yang disebabkan oleh perkhidmatan pihak ketiga`,
  limitation_of_liability_subtitle2: `Penggunaan platform adalah atas risiko anda sendiri.`,

  introduction: `Pengenalan`,
  introduction_subtitle1: `Kami komited untuk melindungi privasi anda dan memastikan maklumat peribadi anda dikendalikan dengan selamat serta bertanggungjawab. Polisi Privasi ini menerangkan bagaimana kami mengumpul, menggunakan, menyimpan, dan melindungi maklumat anda apabila anda menggunakan platform kami.`,
  introduction_subtitle2: `Dengan mengakses atau menggunakan perkhidmatan kami, anda bersetuju dengan terma yang dinyatakan dalam Polisi Privasi ini.`,
  information_we_collect: `Maklumat yang Kami Kumpul`,
  information_we_collect_subtitle1: `Kami mungkin mengumpul jenis maklumat berikut:`,
  information_we_collect_desc1: `Maklumat Peribadi`,
  information_we_collect_desc1_1: `Nama`,
  information_we_collect_desc1_2: `Alamat e-mel`,
  information_we_collect_desc1_3: `Maklumat hubungan`,
  information_we_collect_desc1_4: `Tarikh lahir`,
  information_we_collect_desc1_5: `Maklumat pembayaran`,
  information_we_collect_desc2: `Maklumat Akaun`,
  information_we_collect_desc2_1: `Nama pengguna dan kelayakan log masuk`,
  information_we_collect_desc2_2: `Sejarah transaksi (deposit dan pengeluaran)`,
  information_we_collect_desc2_3: `Aktiviti permainan dan keutamaan`,
  information_we_collect_desc3: `Maklumat Teknikal`,
  information_we_collect_desc3_1: `Alamat IP`,
  information_we_collect_desc3_2: `Maklumat peranti`,
  information_we_collect_desc3_3: `Jenis pelayar`,
  information_cookies: `Kuki dan data penggunaan`,
  how_we_use_information: `Cara Kami Menggunakan Maklumat Anda`,
  how_we_use_information_subtitle1: `Maklumat anda boleh digunakan untuk tujuan berikut:`,
  how_we_use_information_desc1: `Mewujudkan dan mengurus akaun anda`,
  how_we_use_information_desc2: `Memproses deposit dan pengeluaran`,
  how_we_use_information_desc3: `Menyediakan sokongan pelanggan`,
  how_we_use_information_desc4: `Menambah baik platform dan pengalaman pengguna`,
  how_we_use_information_desc5: `Mengesan dan mencegah penipuan, penyalahgunaan, atau aktiviti haram`,
  how_we_use_information_desc6: `Mematuhi keperluan undang-undang dan peraturan`,
  sharing_of_information: `Perkongsian Maklumat`,
  sharing_of_information_subtitle1: `Kami tidak menjual data peribadi anda. Walau bagaimanapun, kami mungkin berkongsi maklumat anda dengan:`,
  sharing_of_information_desc1: `Penyedia perkhidmatan (pemproses pembayaran, perkhidmatan IT)`,
  sharing_of_information_desc2: `Penyedia permainan untuk pengesahan permainan dan transaksi`,
  sharing_of_information_desc3: `Pihak berkuasa kawal selia jika diperlukan oleh undang-undang`,
  sharing_of_information_desc4: `Agensi pencegahan penipuan bagi melindungi daripada penyalahgunaan`,
  sharing_of_information_subtitle2: `Semua pihak ketiga dikehendaki mengendalikan data anda dengan selamat.`,
  data_security: `Keselamatan Data`,
  data_security_subtitle1: `Kami melaksanakan langkah keselamatan yang canggih untuk melindungi maklumat anda, termasuk:`,
  data_security_desc1: `Teknologi penyulitan`,
  data_security_desc2: `Pelayan selamat dan firewall`,
  data_security_desc3: `Sistem kawalan akses dan pemantauan`,
  data_security_subtitle2: `Walaupun kami berusaha melindungi data anda, tiada sistem yang benar-benar selamat. Pengguna bertanggungjawab untuk menjaga kerahsiaan maklumat log masuk mereka.`,
  cookie_policy: `Polisi Kuki`,
  cookie_policy_subtitle1: `Kami menggunakan kuki dan teknologi yang serupa untuk:`,
  cookie_policy_desc1: `Meningkatkan pengalaman pengguna`,
  cookie_policy_desc2: `Mengingati keutamaan pengguna`,
  cookie_policy_desc3: `Menganalisis penggunaan platform`,
  cookie_policy_subtitle2: `Anda boleh mematikan kuki melalui tetapan pelayar, namun sesetengah fungsi platform mungkin tidak berfungsi dengan baik.`,
  data_retention: `Penyimpanan Data`,
  data_retention_subtitle1: `Kami menyimpan data peribadi anda hanya selama yang diperlukan untuk:`,
  data_retention_desc1: `Memenuhi tujuan yang dinyatakan dalam polisi ini`,
  data_retention_desc2: `Mematuhi keperluan undang-undang dan peraturan`,
  data_retention_subtitle2: `Apabila data tidak lagi diperlukan, ia akan dipadamkan atau dianonimkan dengan selamat.`,
  your_rights: `Hak Anda`,
  your_rights_subtitle1: `Bergantung kepada bidang kuasa anda, anda mungkin mempunyai hak untuk:`,
  your_rights_desc1: `Mengakses data peribadi anda`,
  your_rights_desc2: `Meminta pembetulan maklumat yang tidak tepat`,
  your_rights_desc3: `Meminta pemadaman data anda`,
  your_rights_desc4: `Mengehadkan atau membantah pemprosesan data`,
  your_rights_subtitle2: `Untuk menggunakan hak-hak ini, sila hubungi pasukan sokongan kami.`,
  add_home_screen: 'Tambah ke Skrin Utama',
  tap_share_button: 'Ketuk butang kongsi',
  tap_add_home_screen: "Ketuk 'Tambah ke Skrin Utama'",
  tap_add: "Ketuk 'Tambah'",
  for_quick_access: 'Untuk Akses Pantas',
  web: `WEB`,
  app_caps: `APP`,
  fast_caps: `CEPAT`,
  step_one: `Langkah 1`,
  step_two: `Langkah 2`,
  step_three: `Langkah 3`,
  step_four: `Langkah 4`,
  add_to_home_screen: `Tambahkan pada Skrin Utama`,

  top_casino: `Padu99`,
  play_big: `Main Padu, Menang Selalu`,

  asia_biggest_most_trusted: `Padu99, Platform Terbesar Dan Paling Dipercayai. Bekerjasama Dengan Saba Sports, Jenama No. 1 Asia Peneraju Pasaran Sukan, Untuk Meningkatkan Perjalanan Pertaruhan Anda!`,
  fast: 'Pantas',
  seamless: 'Tanpa gangguan',
  stay_updated: 'Kekal dikemas kini',
  smart_betting: 'Pertaruhan pintar',
  security: 'Keselamatan',
  live_streaming: 'Siaran langsung',
  no_login_required: 'Tiada log masuk diperlukan selepas log masuk pertama untuk mengakses aplikasi Saba Sports.',
  deposit_and_withdraw_direct: 'Deposit dan pengeluaran boleh dibuat terus melalui aplikasi.',
  receive_instant_notification: 'Terima pemberitahuan segera untuk permainan pilihan.',
  access_valuable_information: 'Akses maklumat dan statistik berharga untuk membuat keputusan yang lebih bijak.',
  guarantees_data_transaction:
    'Menjamin keselamatan data dan transaksi dengan ciri-ciri canggih, membina kepercayaan dan menyediakan transaksi yang sangat selamat untuk pemain.',
  live_watches: 'Tonton perlawanan secara langsung dalam aplikasi',
  malaysia: `Malaysia`,
  dns_title: 'Tetapkan DNS Awam',
  description_1:
    '1.1.1.1: Faster Internet adalah kaedah pilihan untuk menetapkan Resolver DNS 1.1.1.1 pada peranti iOS dan Android. Ia membolehkan telefon anda dikonfigurasi secara automatik untuk menggunakan 1.1.1.1 pada mana-mana rangkaian yang anda sambungkan, dan menyelesaikan masalah iOS dan Android yang tidak dapat menggunakan Resolver DNS alternatif pada sambungan mudah alih.',
  description_2:
    'Aplikasi ini juga membolehkan anda mengaktifkan penyulitan untuk pertanyaan DNS atau mengaktifkan mod WARP, yang memastikan semua trafik HTTP anda kekal peribadi dan selamat, termasuk pertanyaan DNS anda ke 1.1.1.1.',
  description_3:
    'Anda boleh memilih antara kedua-dua pilihan ini dalam Tetapan 1.1.1.1: Faster Internet. Secara lalai, aplikasi dikonfigurasi ke mod WARP.',
  how_to_provide_faster_internet: 'Cara Menyediakan 1.1.1.1: Faster Internet',
  step1_title: 'Muat turun',
  step1_desc: 'Muat turun 1.1.1.1: Faster Internet secara percuma dari App Store atau Google Play.',
  step2_title: 'Buka',
  step2_desc: 'Buka aplikasi dan terima Terma Perkhidmatan.',
  step3_title: 'Pasang',
  step3_desc: 'Pasang profil VPN yang membolehkan telefon anda menyambung dengan selamat ke 1.1.1.1.',
  step4_title: 'Benarkan',
  step4_desc: 'Benarkan penambahan konfigurasi VPN.',
  step5_title: 'Sambung',
  step5_desc: 'Togol butang WARP kepada Bersambung.',
  provider: 'Pembekal',
  withdrawal_amount: 'Jumlah Pengeluaran',
  withdrawal_remaining: 'Baki Pengeluaran',
  slot: `Slot`,
  mobile_slot: `Slot Mudah Alih`,

  selected_bank_details: `BUTIRAN BANK YANG DIPILIH`,
  withdraw_count: `Kiraan Pengeluaran`,
  weekly_rebate: `Rebate Mingguan`,
  tier_bonus_upgrade: `Bonus Peringkat & Peningkatan`,
  special_birthday_gift: `Hadiah Hari Lahir Istimewa`,
  upgrade_next_tier: `Tingkatkan ke Peringkat Seterusnya`,
  maintenance_requirement: `Keperluan Penyelenggaraan`,
  valid_until: `Sah hingga`,
  membership_renewal: `Pembaharuan Keanggotaan`,

  unlimited: 'Tidak Terbatas',
  yes: 'Ya',
  months: 'Bulan',
  lifetime: 'Seumur Hidup',
  bronze: 'BRONZE',
  silver: 'SILVER',
  gold: 'GOLD',
  platinum: 'PLATINUM',
  diamond: 'DIAMOND',
  royal: 'ROYAL',

  about_us_welcome: `Selamat datang ke Padu99 — Destinasi dipercayai anda untuk hiburan dan permainan dalam talian premium.`,
  about_us_forward_thinking: `Kami adalah syarikat permainan dalam talian yang berpandangan jauh dan komited untuk memberikan pengalaman bertaraf dunia kepada pemain di seluruh dunia. Dibina atas asas inovasi, kebolehpercayaan, dan kepuasan pengguna, platform kami menghimpunkan pelbagai pilihan permainan termasuk slot, kasino langsung, permainan meja, serta pengalaman interaktif lain yang dikuasakan oleh penyedia terkemuka dan bereputasi dalam industri.`,
  about_us_goal: `Matlamat kami adalah jelas: untuk mewujudkan persekitaran di mana pemain dapat menikmati permainan yang lancar, ganjaran menarik, dan ketenangan fikiran sepenuhnya. Kami memahami bahawa kepercayaan adalah segalanya dalam permainan dalam talian, oleh itu kami mengutamakan keadilan, ketelusan, dan keselamatan dalam setiap aspek operasi kami. Semua permainan di platform kami direka mengikut piawaian ketat bagi memastikan keputusan yang adil serta pengalaman yang menyeronokkan.`,
  about_us_beyond_entertainment: `Selain hiburan, kami memberi tumpuan kepada memberikan nilai sebenar kepada pemain kami. Melalui ekosistem ganjaran yang komprehensif — termasuk bonus deposit, mata ganjaran, ganjaran daftar masuk harian, dan promosi roda bertuah — kami berusaha meningkatkan penglibatan sambil memberikan lebih banyak peluang kepada pemain untuk menikmati manfaat daripada masa mereka di platform kami. Setiap ciri direka dengan teliti untuk meningkatkan keseronokan dan potensi ganjaran.`,
  about_us_invest_technology: `Kami juga melabur secara besar dalam teknologi bagi memastikan platform kami kekal pantas, stabil, dan selamat. Daripada sistem penyulitan canggih hingga infrastruktur backend yang kukuh, kami komited untuk melindungi data pengguna serta menyediakan pengalaman permainan yang lancar tanpa gangguan.`,
  about_us_customer_satisfaction: `Kepuasan pelanggan adalah keutamaan kami. Pasukan sokongan profesional kami sentiasa bersedia untuk membantu pemain dengan pantas, menjawab pertanyaan dan menyelesaikan masalah dengan cekap dan penuh perhatian. Kami percaya bahawa perkhidmatan yang baik membina hubungan jangka panjang, dan kami komited untuk menyokong pemain kami pada setiap langkah.`,

  username_must_be: `Nama pengguna mestilah antara 6 hingga 20 aksara`,
  fullname_must_be: `Nama penuh hanya boleh terdiri daripada aksara abjad dan jarak`,
  fullname_required: `Nama penuh diperlukan`,
  password_must_be: `Kata laluan mestilah antara 4 dan 20 aksara`,
  contact_number_must: `No. Telefon mesti bermula dengan 6 dan diikuti dengan 10 atau 11 digit`,
  account_number_required: `Nombor akaun diperlukan`,
  acc: `Acc`,
  agree_tnc: `Anda perlu bersetuju dengan Syarat Penggunaan dan Dasar Privasi untuk log masuk.`,
  i_agree: `Saya Setuju`,
  send_code_mobile: `Kami Akan Menghantar Kod Ke Nombor Telefon Bimbit Anda`,
  correct_code: `Sila masukkan kod yang betul`,
  resend_code: `Hantar Semula Kod`,
  resend_code_now: `Hantar Semula Kod Sekarang`,
  enter_valid_phone: `Sila masukkan nombor telefon yang sah`,
  withdrawal_bank_account_name: `Nama akaun bank pengeluaran mesti sepadan dengan nama penuh yang didaftarkan.`,
  some_game_provider: `Sesetengah penyedia permainan memerlukan 15 hingga 30 minit masa penyegerakan laporan.`,
  please_make_sure_turn_over: `Sila pastikan keperluan pusing ganti anda telah dicapai.`,
  withdrawal_remaining_limit: `Had Baki Pengeluaran`,
  select_promotion: `Pilih Promosi`,
  to_upgrade_to: `untuk menaik taraf kepada`,
  Whatsapp: `Whatsapp`,
  marquee_announcement: `Main Padu, Menang Selalu. Jom Register Sekarang — Promosi Panas, Bonus Pantas, Dan Pengalaman Permainan Yang Tak Terlupakan Menanti Anda!`,
  no_withdraw_bank_account_yet: `Tiada Akaun Pengeluaran lagi`,
  day: `Hari`,
  processing: `Pemprosesan`,
  select_your_bank: `Pilih Bank Anda`,
  add_bank_failed: `Gagal menambah Bank`,
  add_bank: `Tambah Bank`,
  reject: `Tolak`,
  in_progress: `Sedang Dijalankan`,
};

export default ms;
